import * as tokens from '../../../../../tokens/color.light.generated.js';
export const componentColorLight = {
    color: {
        action: {
            componentButton: {
                foreground: {
                    icon: {
                        idle: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_FOREGROUND_ICON_IDLE_LIGHT,
                        hover: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_FOREGROUND_ICON_HOVER_LIGHT,
                        pressed: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_FOREGROUND_ICON_PRESSED_LIGHT,
                        disabled: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_FOREGROUND_ICON_DISABLED_LIGHT
                    }
                },
                surface: {
                    stroke: {
                        idle: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_SURFACE_STROKE_IDLE_LIGHT,
                        hover: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_SURFACE_STROKE_HOVER_LIGHT,
                        pressed: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_SURFACE_STROKE_PRESSED_LIGHT,
                        disabled: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_SURFACE_STROKE_DISABLED_LIGHT
                    },
                    fill: {
                        idle: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_SURFACE_FILL_IDLE_LIGHT,
                        hover: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_SURFACE_FILL_HOVER_LIGHT,
                        pressed: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_SURFACE_FILL_PRESSED_LIGHT,
                        disabled: tokens.CMP_COLOR_ACTION_COMPONENT_BUTTON_SURFACE_FILL_DISABLED_LIGHT
                    }
                }
            },
            iconButton: {
                foreground: {
                    text: {
                        default: tokens.CMP_COLOR_ACTION_ICON_BUTTON_FOREGROUND_TEXT_DEFAULT_LIGHT,
                        selected: tokens.CMP_COLOR_ACTION_ICON_BUTTON_FOREGROUND_TEXT_SELECTED_LIGHT,
                        hover: tokens.CMP_COLOR_ACTION_ICON_BUTTON_FOREGROUND_TEXT_HOVER_LIGHT,
                        pressed: tokens.CMP_COLOR_ACTION_ICON_BUTTON_FOREGROUND_TEXT_PRESSED_LIGHT,
                        disabled: tokens.CMP_COLOR_ACTION_ICON_BUTTON_FOREGROUND_TEXT_DISABLED_LIGHT
                    }
                }
            }
        },
        feedback: {
            notification: {
                foreground: {
                    icon: {
                        default: tokens.CMP_COLOR_FEEDBACK_NOTIFICATION_FOREGROUND_ICON_DEFAULT_LIGHT
                    }
                }
            },
            progressIndicator: {
                foreground: {
                    text: {
                        default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_FOREGROUND_TEXT_DEFAULT_LIGHT,
                        inverted: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_FOREGROUND_TEXT_INVERTED_LIGHT,
                        range: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_FOREGROUND_TEXT_RANGE_DEFAULT_LIGHT
                        }
                    }
                },
                monochrome: {
                    surface: {
                        trainLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_MONOCHROME_SURFACE_TRAIN_LINE_DEFAULT_LIGHT
                        },
                        trackLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_MONOCHROME_SURFACE_TRACK_LINE_DEFAULT_LIGHT
                        }
                    }
                },
                inverted: {
                    surface: {
                        trainLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_INVERTED_SURFACE_TRAIN_LINE_DEFAULT_LIGHT
                        },
                        trackLine: {
                            default: tokens.CMP_COLOR_FEEDBACK_PROGRESS_INDICATOR_INVERTED_SURFACE_TRACK_LINE_DEFAULT_LIGHT
                        }
                    }
                }
            }
        },
        ui: {
            avatar: {
                loggedIn: {
                    surface: {
                        fill: {
                            idle: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_SURFACE_FILL_IDLE_LIGHT,
                            interactive: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_SURFACE_FILL_INTERACTIVE_LIGHT,
                            selected: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_SURFACE_FILL_SELECTED_LIGHT,
                            disabled: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_SURFACE_FILL_DISABLED_LIGHT
                        },
                        stroke: {
                            idle: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_SURFACE_STROKE_IDLE_LIGHT,
                            interactive: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_SURFACE_STROKE_INTERACTIVE_LIGHT,
                            selected: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_SURFACE_STROKE_SELECTED_LIGHT,
                            disabled: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_SURFACE_STROKE_DISABLED_LIGHT
                        }
                    },
                    foreground: {
                        icons: {
                            idle: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_FOREGROUND_ICONS_IDLE_LIGHT,
                            interactive: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_FOREGROUND_ICONS_INTERACTIVE_LIGHT,
                            selected: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_FOREGROUND_ICONS_SELECTED_LIGHT,
                            disabled: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_FOREGROUND_ICONS_DISABLED_LIGHT
                        },
                        text: {
                            idle: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_FOREGROUND_TEXT_IDLE_LIGHT,
                            interactive: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_FOREGROUND_TEXT_INTERACTIVE_LIGHT,
                            selected: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_FOREGROUND_TEXT_SELECTED_LIGHT,
                            disabled: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_FOREGROUND_TEXT_DISABLED_LIGHT
                        }
                    },
                    image: {
                        surface: {
                            stroke: {
                                idle: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_IMAGE_SURFACE_STROKE_IDLE_LIGHT,
                                interactive: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_IMAGE_SURFACE_STROKE_INTERACTIVE_LIGHT,
                                selected: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_IMAGE_SURFACE_STROKE_SELECTED_LIGHT,
                                disabled: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_IMAGE_SURFACE_STROKE_DISABLED_LIGHT
                            },
                            imageStateLayer: {
                                fill: {
                                    idle: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_IMAGE_SURFACE_IMAGE_STATE_LAYER_FILL_IDLE_LIGHT,
                                    interactive: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_IMAGE_SURFACE_IMAGE_STATE_LAYER_FILL_INTERACTIVE_LIGHT,
                                    selected: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_IMAGE_SURFACE_IMAGE_STATE_LAYER_FILL_SELECTED_LIGHT,
                                    disabled: tokens.CMP_COLOR_UI_AVATAR_LOGGED_IN_IMAGE_SURFACE_IMAGE_STATE_LAYER_FILL_DISABLED_LIGHT
                                }
                            }
                        }
                    }
                },
                loggedOut: {
                    surface: {
                        fill: {
                            idle: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_SURFACE_FILL_IDLE_LIGHT,
                            interactive: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_SURFACE_FILL_INTERACTIVE_LIGHT,
                            selected: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_SURFACE_FILL_SELECTED_LIGHT,
                            disabled: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_SURFACE_FILL_DISABLED_LIGHT
                        },
                        stroke: {
                            idle: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_SURFACE_STROKE_IDLE_LIGHT,
                            interactive: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_SURFACE_STROKE_INTERACTIVE_LIGHT,
                            selected: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_SURFACE_STROKE_SELECTED_LIGHT,
                            disabled: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_SURFACE_STROKE_DISABLED_LIGHT
                        }
                    },
                    foreground: {
                        icons: {
                            idle: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_FOREGROUND_ICONS_IDLE_LIGHT,
                            interactive: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_FOREGROUND_ICONS_INTERACTIVE_LIGHT,
                            selected: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_FOREGROUND_ICONS_SELECTED_LIGHT,
                            disabled: tokens.CMP_COLOR_UI_AVATAR_LOGGED_OUT_FOREGROUND_ICONS_DISABLED_LIGHT
                        }
                    }
                }
            },
            skeleton: {
                surface: {
                    fill: tokens.CMP_COLOR_UI_SKELETON_SURFACE_FILL_LIGHT
                }
            },
            table: {
                foreground: {
                    text: {
                        title: {
                            default: tokens.CMP_COLOR_UI_TABLE_FOREGROUND_TEXT_TITLE_DEFAULT_LIGHT
                        },
                        headline: {
                            default: tokens.CMP_COLOR_UI_TABLE_FOREGROUND_TEXT_HEADLINE_DEFAULT_LIGHT
                        },
                        copy: {
                            default: tokens.CMP_COLOR_UI_TABLE_FOREGROUND_TEXT_COPY_DEFAULT_LIGHT
                        }
                    },
                    divider: {
                        default: tokens.CMP_COLOR_UI_TABLE_FOREGROUND_DIVIDER_DEFAULT_LIGHT
                    }
                },
                surface: {
                    fill: {
                        default: tokens.CMP_COLOR_UI_TABLE_SURFACE_FILL_DEFAULT_LIGHT
                    }
                }
            },
            value: {
                foreground: {
                    text: {
                        label: tokens.CMP_COLOR_UI_VALUE_FOREGROUND_TEXT_LABEL_LIGHT,
                        caption: tokens.CMP_COLOR_UI_VALUE_FOREGROUND_TEXT_CAPTION_LIGHT
                    }
                }
            },
            tag: {
                readOnly: {
                    icon: {
                        default: tokens.CMP_COLOR_UI_TAG_READ_ONLY_ICON_DEFAULT_LIGHT
                    },
                    text: {
                        default: tokens.CMP_COLOR_UI_TAG_READ_ONLY_TEXT_DEFAULT_LIGHT
                    },
                    surface: {
                        fill: {
                            default: tokens.CMP_COLOR_UI_TAG_READ_ONLY_SURFACE_FILL_DEFAULT_LIGHT
                        },
                        stroke: {
                            default: tokens.CMP_COLOR_UI_TAG_READ_ONLY_SURFACE_STROKE_DEFAULT_LIGHT
                        }
                    }
                },
                unselected: {
                    surface: {
                        fill: {
                            default: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_FILL_DEFAULT_LIGHT,
                            interactive: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_FILL_INTERACTIVE_LIGHT,
                            disabled: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_FILL_DISABLED_LIGHT,
                            encourage: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_FILL_ENCOURAGE_LIGHT
                        },
                        stroke: {
                            default: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_STROKE_DEFAULT_LIGHT,
                            interactive: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_STROKE_INTERACTIVE_LIGHT,
                            disabled: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_STROKE_DISABLED_LIGHT,
                            encourage: tokens.CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_STROKE_ENCOURAGE_LIGHT
                        }
                    },
                    text: {
                        default: tokens.CMP_COLOR_UI_TAG_UNSELECTED_TEXT_DEFAULT_LIGHT,
                        interactive: tokens.CMP_COLOR_UI_TAG_UNSELECTED_TEXT_INTERACTIVE_LIGHT,
                        disabled: tokens.CMP_COLOR_UI_TAG_UNSELECTED_TEXT_DISABLED_LIGHT,
                        encourage: tokens.CMP_COLOR_UI_TAG_UNSELECTED_TEXT_ENCOURAGE_LIGHT
                    },
                    icon: {
                        default: tokens.CMP_COLOR_UI_TAG_UNSELECTED_ICON_DEFAULT_LIGHT,
                        interactive: tokens.CMP_COLOR_UI_TAG_UNSELECTED_ICON_INTERACTIVE_LIGHT,
                        disabled: tokens.CMP_COLOR_UI_TAG_UNSELECTED_ICON_DISABLED_LIGHT,
                        encourage: tokens.CMP_COLOR_UI_TAG_UNSELECTED_ICON_ENCOURAGE_LIGHT
                    }
                },
                selected: {
                    surface: {
                        fill: {
                            default: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_FILL_DEFAULT_LIGHT,
                            interactive: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_FILL_INTERACTIVE_LIGHT,
                            disabled: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_FILL_DISABLED_LIGHT
                        },
                        stroke: {
                            default: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_STROKE_DEFAULT_LIGHT,
                            interactive: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_STROKE_INTERACTIVE_LIGHT,
                            disabled: tokens.CMP_COLOR_UI_TAG_SELECTED_SURFACE_STROKE_DISABLED_LIGHT
                        }
                    },
                    text: {
                        default: tokens.CMP_COLOR_UI_TAG_SELECTED_TEXT_DEFAULT_LIGHT,
                        interactive: tokens.CMP_COLOR_UI_TAG_SELECTED_TEXT_INTERACTIVE_LIGHT,
                        disabled: tokens.CMP_COLOR_UI_TAG_SELECTED_TEXT_DISABLED_LIGHT
                    },
                    icon: {
                        default: tokens.CMP_COLOR_UI_TAG_SELECTED_ICON_DEFAULT_LIGHT,
                        interactive: tokens.CMP_COLOR_UI_TAG_SELECTED_ICON_INTERACTIVE_LIGHT,
                        disabled: tokens.CMP_COLOR_UI_TAG_SELECTED_ICON_DISABLED_LIGHT
                    }
                }
            },
            productTile: {
                surface: {
                    fill: {
                        default: tokens.CMP_COLOR_UI_PRODUCT_TILE_SURFACE_FILL_DEFAULT_LIGHT
                    },
                    stroke: {
                        default: tokens.CMP_COLOR_UI_PRODUCT_TILE_SURFACE_STROKE_DEFAULT_LIGHT
                    }
                }
            },
            productCard: {
                surface: {
                    fill: {
                        default: tokens.CMP_COLOR_UI_PRODUCT_CARD_SURFACE_FILL_DEFAULT_LIGHT
                    },
                    stroke: {
                        default: tokens.CMP_COLOR_UI_PRODUCT_CARD_SURFACE_STROKE_DEFAULT_LIGHT
                    }
                }
            },
            accordion: {
                surface: {
                    idle: tokens.CMP_COLOR_UI_ACCORDION_SURFACE_IDLE_LIGHT,
                    disabled: tokens.CMP_COLOR_UI_ACCORDION_SURFACE_DISABLED_LIGHT,
                    focus: tokens.CMP_COLOR_UI_ACCORDION_SURFACE_FOCUS_LIGHT,
                    interactive: tokens.CMP_COLOR_UI_ACCORDION_SURFACE_INTERACTIVE_LIGHT
                }
            }
        },
        navigation: {
            tabs: {
                foreground: {
                    icon: {
                        default: tokens.CMP_COLOR_NAVIGATION_TABS_FOREGROUND_ICON_DEFAULT_LIGHT,
                        disabled: tokens.CMP_COLOR_NAVIGATION_TABS_FOREGROUND_ICON_DISABLED_LIGHT,
                        interactive: tokens.CMP_COLOR_NAVIGATION_TABS_FOREGROUND_ICON_INTERACTIVE_LIGHT,
                        active: tokens.CMP_COLOR_NAVIGATION_TABS_FOREGROUND_ICON_ACTIVE_LIGHT
                    },
                    text: {
                        default: tokens.CMP_COLOR_NAVIGATION_TABS_FOREGROUND_TEXT_DEFAULT_LIGHT,
                        disabled: tokens.CMP_COLOR_NAVIGATION_TABS_FOREGROUND_TEXT_DISABLED_LIGHT,
                        interactive: tokens.CMP_COLOR_NAVIGATION_TABS_FOREGROUND_TEXT_INTERACTIVE_LIGHT,
                        active: tokens.CMP_COLOR_NAVIGATION_TABS_FOREGROUND_TEXT_ACTIVE_LIGHT
                    }
                },
                surface: {
                    stroke: {
                        default: tokens.CMP_COLOR_NAVIGATION_TABS_SURFACE_STROKE_DEFAULT_LIGHT,
                        disabled: tokens.CMP_COLOR_NAVIGATION_TABS_SURFACE_STROKE_DISABLED_LIGHT,
                        interactive: tokens.CMP_COLOR_NAVIGATION_TABS_SURFACE_STROKE_INTERACTIVE_LIGHT,
                        active: tokens.CMP_COLOR_NAVIGATION_TABS_SURFACE_STROKE_ACTIVE_LIGHT
                    },
                    fill: {
                        default: tokens.CMP_COLOR_NAVIGATION_TABS_SURFACE_FILL_DEFAULT_LIGHT,
                        disabled: tokens.CMP_COLOR_NAVIGATION_TABS_SURFACE_FILL_DISABLED_LIGHT,
                        interactive: tokens.CMP_COLOR_NAVIGATION_TABS_SURFACE_FILL_INTERACTIVE_LIGHT,
                        active: tokens.CMP_COLOR_NAVIGATION_TABS_SURFACE_FILL_ACTIVE_LIGHT
                    }
                }
            },
            textLink: {
                foreground: {
                    default: tokens.CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_DEFAULT_LIGHT,
                    interactive: tokens.CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_INTERACTIVE_LIGHT,
                    disabled: tokens.CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_DISABLED_LIGHT
                }
            }
        },
        forms: {
            slider: {
                surface: {
                    track: {
                        default: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_TRACK_DEFAULT_LIGHT
                    },
                    progress: {
                        default: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_PROGRESS_DEFAULT_LIGHT,
                        interactive: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_PROGRESS_INTERACTIVE_LIGHT,
                        disabled: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_PROGRESS_DISABLED_LIGHT,
                        error: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_PROGRESS_ERROR_LIGHT
                    },
                    handle: {
                        fill: {
                            default: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_FILL_DEFAULT_LIGHT,
                            disabled: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_FILL_DISABLED_LIGHT,
                            error: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_FILL_ERROR_LIGHT
                        },
                        stroke: {
                            default: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_STROKE_DEFAULT_LIGHT,
                            disabled: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_STROKE_DISABLED_LIGHT,
                            error: tokens.CMP_COLOR_FORMS_SLIDER_SURFACE_HANDLE_STROKE_ERROR_LIGHT
                        }
                    }
                }
            },
            listItem: {
                surface: {
                    fill: {
                        default: tokens.CMP_COLOR_FORMS_LIST_ITEM_SURFACE_FILL_DEFAULT_LIGHT,
                        interactive: tokens.CMP_COLOR_FORMS_LIST_ITEM_SURFACE_FILL_INTERACTIVE_LIGHT
                    }
                }
            },
            extendedSelection: {
                surface: {
                    fill: {
                        active: tokens.CMP_COLOR_FORMS_EXTENDED_SELECTION_SURFACE_FILL_ACTIVE_LIGHT,
                        default: tokens.CMP_COLOR_FORMS_EXTENDED_SELECTION_SURFACE_FILL_DEFAULT_LIGHT
                    },
                    stroke: {
                        default: tokens.CMP_COLOR_FORMS_EXTENDED_SELECTION_SURFACE_STROKE_DEFAULT_LIGHT,
                        active: tokens.CMP_COLOR_FORMS_EXTENDED_SELECTION_SURFACE_STROKE_ACTIVE_LIGHT
                    }
                }
            },
            toggle: {
                inactive: {
                    surface: {
                        fill: {
                            default: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_FILL_DEFAULT_LIGHT,
                            interactive: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_FILL_INTERACTIVE_LIGHT,
                            disabled: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_FILL_DISABLED_LIGHT
                        },
                        stroke: {
                            default: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_STROKE_DEFAULT_LIGHT,
                            interactive: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_STROKE_INTERACTIVE_LIGHT,
                            disabled: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_SURFACE_STROKE_DISABLED_LIGHT
                        }
                    },
                    foreground: {
                        handle: {
                            fill: {
                                default: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_FOREGROUND_HANDLE_FILL_DEFAULT_LIGHT,
                                interactive: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_FOREGROUND_HANDLE_FILL_INTERACTIVE_LIGHT,
                                disabled: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_FOREGROUND_HANDLE_FILL_DISABLED_LIGHT
                            }
                        },
                        icon: {
                            default: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_FOREGROUND_ICON_DEFAULT_LIGHT,
                            interactive: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_FOREGROUND_ICON_INTERACTIVE_LIGHT,
                            disabled: tokens.CMP_COLOR_FORMS_TOGGLE_INACTIVE_FOREGROUND_ICON_DISABLED_LIGHT
                        }
                    }
                },
                active: {
                    surface: {
                        fill: {
                            default: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_SURFACE_FILL_DEFAULT_LIGHT,
                            interactive: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_SURFACE_FILL_INTERACTIVE_LIGHT,
                            disabled: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_SURFACE_FILL_DISABLED_LIGHT
                        },
                        stroke: {
                            default: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_SURFACE_STROKE_DEFAULT_LIGHT,
                            interactive: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_SURFACE_STROKE_INTERACTIVE_LIGHT,
                            disabled: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_SURFACE_STROKE_DISABLED_LIGHT
                        }
                    },
                    foreground: {
                        handle: {
                            fill: {
                                default: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_FOREGROUND_HANDLE_FILL_DEFAULT_LIGHT,
                                interactive: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_FOREGROUND_HANDLE_FILL_INTERACTIVE_LIGHT,
                                disabled: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_FOREGROUND_HANDLE_FILL_DISABLED_LIGHT
                            }
                        },
                        icon: {
                            default: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_FOREGROUND_ICON_DEFAULT_LIGHT,
                            interactive: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_FOREGROUND_ICON_INTERACTIVE_LIGHT,
                            disabled: tokens.CMP_COLOR_FORMS_TOGGLE_ACTIVE_FOREGROUND_ICON_DISABLED_LIGHT
                        }
                    }
                }
            }
        }
    }
};
//# sourceMappingURL=color.light.js.map